export interface FieldBlock {
    field_block: string;
    type: string;
    name: string;
    block: string;
}

export interface ContentBlock {
    name: string;  // An array of translated names
    block: string;   // The block type identifier
}

export enum FieldBlockType {
    ContentBox = 'content-box',
    PageBreak = 'page-break',
    UploadPdf = 'upload-pdf',
    AddAttachment = 'add-attachment',
    ImageBlock = 'image-block',
    ContentLibrary = 'content-library',
    FormBuilder = 'form-builder',
    Table = 'table',
    ContentFields = 'content-fields',
    ProductTable = "product-table",
    ProductTableSummary = "product-table-summary"
}

export enum ElementPosition {
    Top = 'top',
    Bottom = 'bottom',
    Left = 'left',
    Right = 'right'
}